import {Map} from '../shared/Map';
import ScrollMagic from 'scrollmagic';

$(() => {
    new Map('.js-contacts-map');

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);
});



// WEBPACK FOOTER //
// ./app/scripts/pages/contacts.js